import React from "react";
import * as Option from "fp-ts/lib/Option";
export var render = function (blocks, data) {
    return blocks
        .map(function (block) { return block(data); })
        .filter(Option.isSome)
        .map(function (option) { return option.value; })
        .map(function (_a) {
        var View = _a.View, key = _a.key;
        return React.createElement(View, { key: key });
    });
};
